<mat-form-field [appearance]="appearance">
  <mat-label>{{ label }}</mat-label>
  <input matInput [matDatepicker]="picker" [formControl]="dateControl" style="display:none">

  <span class="datetime-label">{{ displayLabel }}</span>
  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>

  <mat-datepicker #picker (opened)="syncWheelsToConfirmedValue()">
    <mat-datepicker-actions class="full-width-actions">
      <div class="time-picker-main-row">
        <div class="column-wrapper">
          <button type="button" class="arrow-btn" (click)="step('hour', -1)">▲</button>
          <div class="wheel-box">
            <input type="number" class="wheel-input" [formControl]="hourControl" (wheel)="forwardScroll($event, 'hour')"
              (input)="onManualType('hour')">
            <div class="wheel" #hourWheel (scroll)="onScroll($event, 'hour')">
              <div *ngFor="let h of hours" class="wheel-item">{{ h | number:'2.0' }}</div>
            </div>
          </div>
          <button type="button" class="arrow-btn" (click)="step('hour', 1)">▼</button>
        </div>

        <span class="sep">:</span>

        <div class="column-wrapper">
          <button type="button" class="arrow-btn" (click)="step('minute', -1)">▲</button>
          <div class="wheel-box">
            <input type="number" class="wheel-input" [formControl]="minuteControl"
              (wheel)="forwardScroll($event, 'minute')" (input)="onManualType('minute')">
            <div class="wheel" #minWheel (scroll)="onScroll($event, 'minute')">
              <div *ngFor="let m of minutes" class="wheel-item">{{ m | number:'2.0' }}</div>
            </div>
          </div>
          <button type="button" class="arrow-btn" (click)="step('minute', 1)">▼</button>
        </div>

        <span class="sep">:</span>

        <div class="column-wrapper">
          <button type="button" class="arrow-btn" (click)="step('second', -1)">▲</button>
          <div class="wheel-box">
            <input type="number" class="wheel-input" [formControl]="secondControl"
              (wheel)="forwardScroll($event, 'second')" (input)="onManualType('second')">
            <div class="wheel" #secWheel (scroll)="onScroll($event, 'second')">
              <div *ngFor="let s of seconds" class="wheel-item">{{ s | number:'2.0' }}</div>
            </div>
          </div>
          <button type="button" class="arrow-btn" (click)="step('second', 1)">▼</button>
        </div>
      </div>

      <div class="button-row">
        <button mat-raised-button color="primary" class="date-apply-button" matDatepickerApply
          (click)="applyTime()">Apply</button>
      </div>
    </mat-datepicker-actions>
  </mat-datepicker>
</mat-form-field>